export default __webpack_public_path__ + "static/media/seguranca.9ad0f3c8.jpg";